import { render } from "./ScoutPlayers.vue?vue&type=template&id=238445f9"
import script from "./ScoutPlayers.vue?vue&type=script&lang=js"
export * from "./ScoutPlayers.vue?vue&type=script&lang=js"

import "./ScoutPlayers.vue?vue&type=style&index=0&id=238445f9&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__